<!-- 数据分析模块 -->
<!--
    数据分析模块分为两个部分
        1.左侧的监测点列表
        2.右侧的数据图展示区域 -->
<template>
  <div class='uk-flex'>
    <!-- 监测点列表 -->
    <carrierAnalysed :carrierList='carrierList' style='width: 250px;'></carrierAnalysed>
    <!-- 数据展示区域 -->
    <AnalysisPanel class='analysis-panel-wrapper'></AnalysisPanel>
  </div>
</template>

<script>
import carrierAnalysed from './component/carrierList/carrierAnalysed.vue'
import AnalysisPanel from './component/AnalysisPanel/AnalysisPanel.vue'

export default {
  data () {
    return {
      carrierList: []
    }
  },
  components: {
    carrierAnalysed,
    AnalysisPanel
  }
}
</script>

<style scoped>
.analysis-panel-wrapper {
  width: calc(100% - 250px);
  overflow-x: auto;
}
</style>
